import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { CisFertigation } from '@/types/cisFertigation'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchCisFertigation(
  interfaceId: number,
  pipeId: number,
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<CisFertigation>, any> {
  return useQuery(
    [queryKeys.cisFertigation, interfaceId, searchParams],
    async () => {
      const { data } = await cisFertigationDataConfig.getAll(
        interfaceId.toString(),
        pipeId.toString(),
        {
          ...searchParams,
        },
      )
      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchCisFertigation
